export default __webpack_public_path__ + "static/media/1904.417de89e.png";